import $ from 'jquery';


/*
 * Register 7pass user in tvsmiles,
 * if is new register,
 * if a 461 is received, the user is already registered with another account
 */
function tvsmilesRegister(that, clientId, tvsAddress, authorization, refreshToken, cb) {
    const headers = {
        'content-type': 'application/json',
        authorization: `Basic ${authorization}`,
    };

    const data = `{
        clientId: '${clientId}',
        refreshToken: {
            token: '${refreshToken}'
        }
    }`;

    const settings = {
        url: `${tvsAddress}/api/v4/user/register/7pass`,
        method: 'POST',
        headers,
        data,
    };

    $.ajax(settings)
        .done(() => {
            console.log('FINISH, USER CREATED');
            that.setState({ sevenPass: 'FINISH, USER CREATED' });
            cb();
        })
        .fail((jqXHR) => {
            console.error('User not created');
            console.error(jqXHR);

            switch (jqXHR.status) {
            case 461: {
                console.log('User already registered to another 7Pass Account.');
                that.setState({ sevenPass: `User already registered to another 7pass Account (${jqXHR.responseJSON.data.email})` });
                cb();
                break;
            }
            default: {
                console.error(`Error Status code: ${jqXHR.status}`);
            }
            }
        });
}


/*
 * TVSmiles Login, Return if the user exists or not
 * By now, I don't care about the output, a 200 is enought
 */
export default function tvsmilesLogin(that, clientId, tvsAddress, uuid, refreshToken, cb) {
    // Create credential for POST request
    const authorization = new Buffer(`${uuid}:`).toString('base64');

    // Create the headers
    const headers = {
        'content-type': 'application/json',
        authorization: `Basic ${authorization}`,
    };

    // Fill out the body
    const data = `{
        clientId: '${clientId}',
        refreshToken: {
            token: '${refreshToken}'
        }
    }`;

    // Wrap everything in settings (and send it)
    const settings = {
        url: `${tvsAddress}/api/v4/user/login/7pass`,
        method: 'POST',
        headers,
        data,
    };

    // Send POST request
    $.ajax(settings)
        .done(() => {
            // If login is successful, ends the procedure
            console.log('EXISTING USER LOGGED IN');
            that.setState({ sevenPass: 'EXISTING USER LOGGED IN' });
            cb();
        })
        .fail((jqXHR) => {
            switch (jqXHR.status) {
            case 401:
                // If 401, something went wrong w/ the refreshing token,
                // [error is wrong, apparently 401 is not depending on authorisation]
                console.error('401 - Unauthorized, probably due to wrong refreshing token');
                that.setState({ sevenPass: '401 -EXISTING USER LOGGED IN' });
                break;
            case 404:
                // If 404, the user is not existing, need to register it
                console.log('404 - User not existing, need to register');
                tvsmilesRegister(that, clientId, tvsAddress, authorization, refreshToken, cb);
                break;
            default:
                console.error(jqXHR);
            }
        });
}



// WEBPACK FOOTER //
// ./src/campaign/challenges/sevenPassLogin/tvsmilesAccountManagement.jsx